export default __webpack_public_path__ + "static/media/sparck-appreciation-card-header-6.d01f5274.png";